import { cn } from '@/lib/utils'

interface LogoMarkProps {
  readonly className?: string
  readonly size?: number
}

export function LogoMark({ className, size = 24 }: LogoMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      role="img"
      aria-label="MindWeb"
      className={cn('text-indigo-500 dark:text-indigo-300 shrink-0', className)}
    >
      <g stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        <line x1="12" y1="14" x2="12" y2="50" />
        <line x1="12" y1="14" x2="32" y2="34" />
        <line x1="32" y1="34" x2="52" y2="14" />
        <line x1="52" y1="14" x2="52" y2="50" />
      </g>
      <circle cx="12" cy="14" r="5" fill="currentColor" />
      <circle cx="52" cy="14" r="5" fill="currentColor" />
      <circle cx="12" cy="50" r="5" fill="currentColor" />
      <circle cx="52" cy="50" r="5" fill="currentColor" />
      <circle cx="32" cy="34" r="6" className="fill-amber-400" />
    </svg>
  )
}

interface LogoProps {
  readonly className?: string
  readonly size?: number
  readonly textClassName?: string
}

export function Logo({ className, size = 22, textClassName }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark size={size} />
      <span className={cn('text-lg font-bold tracking-tight text-foreground', textClassName)}>
        Mind<span className="text-indigo-500 dark:text-indigo-300">Web</span>
      </span>
    </span>
  )
}
